import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function LinkTo({ to, children }) {
    const { pathname } = useLocation();
    return <Link to={{ pathname: to, state: { from: pathname } }}>{children}</Link>;
}
